console.log(`
\ _   _      _ _         _____ _
| | | | ___| | | ___   |_   _| |__   ___ _ __ ___
| |_| |/ _ \\ | |/ _ \\    | | | '_ \\ / _ \\ '__/ _ \\
|  _  |  __/ | | (_) |   | | | | | |  __/ | |  __/
|_| |_|\\___|_|_|\\___/    |_| |_| |_|\\___|_|  \\___|
`);

/* +-----------------------------------------+
|           GLOBALS AREA             		 |
+-----------------------------------------+ */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";

import "@iconify/iconify";

gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

window.DEBUG = false;
window.MNK = !ScrollTrigger.isTouch;
window.TOUCH = !!ScrollTrigger.isTouch;

/* +-----------------------------------------+
|           IMPORTS AREA             		 |
+-----------------------------------------+ */

// Swiper
import initSwipers from "./swiper/initSwipers";

// CSS
import "../styles/bootstrap/bootstrap.scss";
import "../styles/frontend.scss";

// Bootstrap
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/tab";

// GSAP
import initGsap from "./gsap/initGsap";
import initGsapTriggers from "./gsap/utilities/initGsapTriggers";
import gsapScrollTo from "./gsap/utilities/gsapScrollTo";

// Utilities
import initLoader from "./utilities/initLoader";
import getDimensions from "./utilities/getDimensions";
import initMouseFollower from "./utilities/initMouseFollower";
import initGlightbox from "./utilities/initGlightbox";
import initReadSmore from "./utilities/initReadSmore";
import kobleQuickView from "./utilities/kobleQuickView";
import initMaps from "./utilities/initMaps";
import appendToBody from "./utilities/appendToBody";
import togglePairedCheckboxes from "./utilities/togglePairedCheckboxes";
import initToastify from "./utilities/initToastify";
import initShare from "./utilities/initShare";
import currencySwitcher from "./utilities/currencySwitcher";
import initCleave from "./utilities/initCleave";
import openModalByUrl from "./utilities/openModalByUrl";
import initDrawer from "./utilities/initDrawer";
import getStickyElements from "./utilities/getStickyElements";
import initBlogAjax from "./utilities/initBlogAjax";
import initExpandableCards from "./utilities/initExpandableCards";
import updateListingCount from "./utilities/updateListingCount";

/* +-----------------------------------------+
|           EVENTS AREA             		 |
+-----------------------------------------+ */

// DOC Ready
document.addEventListener(
    "DOMContentLoaded",
    () => {
        
        getDimensions("#app-header", "height");
        getDimensions("#app-topbar", "height");
        getDimensions("#app-navbar", "height");



        initReadSmore();
        initMouseFollower();

        initSwipers();
        initGlightbox();
        kobleQuickView();
        initMaps();
        togglePairedCheckboxes();
        initToastify();
        initShare();
        currencySwitcher();
        initCleave();
        openModalByUrl();
        initDrawer();
        initBlogAjax();
        initExpandableCards();




    },
    { once: true }
);

// WINDOW Ready
window.addEventListener(
    "load",
    () => {
        getStickyElements();
        appendToBody(".modal");

        initLoader();


        // Force refresh after all triggers are created
        setTimeout(() => ScrollTrigger.refresh(), 100);

        const hash = window.location.hash;
        if (hash) gsapScrollTo(hash);
    },
    { once: true }
);

// WS Form
(function ($) {
    $(document).on("wsf-rendered", () => {
        getDimensions(".iti__flag-container", "width");
        getDimensions("input.wsf-field", "height");
    });

    $(document).on(
        "wsf-validate-after",
        function (
            event,
            form_object,
            form_id,
            instance_id,
            form_el,
            form_canvas_el
        ) {
            const transitionSpeed = parseFloat(
                getComputedStyle(form_el[0])
                    .getPropertyValue("--wsf-form-transition-speed")
                    .replace("ms", "")
                    .trim()
            );

            setTimeout(getStickyElements, transitionSpeed);
        }
    );
})(jQuery);

/* +-----------------------------------------+
|           EXECUTION AREA             		 |
+-----------------------------------------+ */

document.addEventListener("DOMContentLoaded", () => {
    initGsapTriggers();
    initGsap();
    gsapScrollTo();
    initLoader();
    initSwipers();
    initExpandableCards();
    updateListingCount();

    // Refresh ScrollTrigger after all resources (images) are loaded
    window.addEventListener("load", () => {
        ScrollTrigger.refresh();
    });
});
